import { z } from "zod";

export const shiftSignatorySchema = z.object({
  _id: z.string(),
  signatoryId: z.string().optional(),
  name: z.string().nullish(),
  role: z.string().nullish(),
  phone: z.string().nullish(),
  email: z.string().nullish(),
  status: z.union([z.literal("REQUESTED"), z.literal("SIGNED"), z.literal("REJECTED")]).optional(),
  signedAt: z.string().optional(),
  method: z.union([
    z.literal("AUTHORIZED_SIGNATORY"),
    z.literal("MANUAL_SIGNATORY"),
    z.literal("ADMIN_SIGNATORY"),
  ]),
});

export const shiftVerificationResponseSchema = z.object({
  shift: z
    .object({
      _id: z.string(),
      note: z.string(),
      signed: z.boolean(),
      verified: z.boolean(),
      verification: z
        .object({
          method: z.union([
            z.literal("AUTHORIZED_SIGNATORY"),
            z.literal("ADMIN_VERIFICATION"),
            z.literal("AUTO_VERIFY"),
            z.literal("AUTO_SCCP_VERIFICATION"),
          ]),
          verifiedBy: z.object({
            _id: z.string().optional(),
            name: z.string().optional(),
            role: z.string().optional(),
            phone: z.string().optional(),
            email: z.string().optional(),
          }),
          verifiedAt: z.string(),
        })
        .nullish(),
      signatory: shiftSignatorySchema.nullish(),
    })
    .optional(),
});

export type ShiftVerificationResponse = z.infer<typeof shiftVerificationResponseSchema>;

export const shiftVerificationRequestSchema = z.object({
  adminId: z.string(),
  shiftId: z.string(),
  note: z.string(),
  signatory: z.object({
    _id: z.string(),
  }),
});

export type ShiftVerificationRequest = z.infer<typeof shiftVerificationRequestSchema>;
